var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"screen-header-tip"},[_c('div',{staticClass:"screen-header-tip__arrow"},[_c('v-icon',{staticClass:"rot-90",attrs:{"size":"16","color":"biennalePrimary"}},[_vm._v("$vuetify.icons.Arrrow")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }